import { render, staticRenderFns } from "./QuotationCostsForm.vue?vue&type=template&id=65f5e5fc"
import script from "./QuotationCostsForm.vue?vue&type=script&lang=js"
export * from "./QuotationCostsForm.vue?vue&type=script&lang=js"
import style0 from "./QuotationCostsForm.vue?vue&type=style&index=0&id=65f5e5fc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports